
function SystemSettingsReducer(state = { serviceExtraAttrSettings: [], systemSettings: [], printTemplate: '', 
                                          printViewPopStatus:'', currentVersion:'', customerExtAttrSettings:[] }, action) {
  switch (action.type) {
    case "GET_EXT_SETTINGS":
      return {
        ...state,
        serviceExtraAttrSettings: action.data
      }
    case "GET_SYSTEM_SETTINGS":
      return {
        ...state,
        systemSettings: action.data
      }
    case "GET_PRINT_TEMPLATE":
      return {
        ...state,
        printTemplate: action.data
      }
    case "PRINT_VIEW_POPSTATUS":
      return {
        ...state,
        printViewPopStatus: action.data
      }
      case "CHECK_VERSION":
        return {
          ...state,
          currentVersion:action.data
        }
        case "GET_CUSTOMER_EXT_SETTINGS":
          return{
            ...state,
            customerExtAttrSettings:action.data
          }
    default:
      return state;
  }

}
export default SystemSettingsReducer;